import React, { useState } from 'react'
import LoginImg from '../../assets/images/MainscreenImage.png'
import '../login/Login.scss'
import OtpInput from 'react-otp-input';
import Logo from '../../assets/images/mainLogo.png'
import { useNavigate } from 'react-router-dom'
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from 'react-redux';
import { login } from './Slice/slice';
import { toast } from 'react-toastify';
import Loader from '../../components/loader/Loader';
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {
  const [showCode, setShowCode] = useState(false);
  const [otp, setOtp] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [passwordType, setPasswordType] = useState("password");
  const { isLoading } = useSelector(state => state.loginSlice);

  const routeChange = () => {
    let path = "/dashboard";
    navigate(path);
  }

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text")
      return;
    }
    setPasswordType("password")
  }

  const loginSchema = yup.object().shape({
    email: yup.string().email('Please enter valid Email Id').required("Please enter your email"),
    password: yup.string().required('Password is required')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]{8,}$/,
        'Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and be at least 8 characters long.'
      )

  })

  const { control, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(loginSchema)
  })

  const onSubmit = async (data) => {
    await dispatch(login(data)).unwrap()
      .then((res) => {
        localStorage.setItem('token', res.data.access_token)
        toast.success(res?.message)
        routeChange();
      })
      .catch((error) => {
        console.log(error, '====error')
        toast.error(error?.message)
      })
  };

  return (
    <section className='login' style={{ backgroundColor: '#FFFFFF' }}>
      {isLoading && <Loader />}
      <div className="d-flex justify-content-center align-items-center">
        <div className='col-lg-7 col-md-8 h-100 login-page' >
          <div className="d-flex justify-content-center align-items-center imagecontainer" style={{ margin: 32, backgroundColor: '#f8f7fa', height: window.innerHeight - 64, borderRadius: 20 }}>
            {showCode &&
              <img src={LoginImg} className='loginImage' style={{ objectFit: 'contain', width: '100%', height: window.innerHeight / 2 }} />
            }
            {!showCode &&
              <img src={LoginImg} className='loginImage' style={{ objectFit: 'contain', width: '100%', height: window.innerHeight / 2 }} />
            }
          </div>
        </div>
        <div className='col-md-7 col-lg-5 login-form'>
          <div>
            <img src={Logo} className='logo-img mb-3' />
            {showCode && <p className='welcomeText'>Two-Step Verification 💬</p>}
            {!showCode && <p className='welcomeText m-0'>Welcome to Relphacare! 👋</p>}

            {showCode &&
              <>
                <p className='verifyText'>We sent a verification code to your mobile. Enter the code from the mobile in the field below.</p><p className='mt-2 text-lightgray'>0000000000</p>
              </>
            }
            {!showCode && <p className='verifyText'>Please sign in to your account and start the adventure </p>}

            {showCode &&
              <div className="form-outline ">
                <label className="form-label my-2">Type your 6 digit security code</label>
                <div className='d-flex justify-content-around'>
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderInput={(props) => <input {...props} style={{ width: 60 }} className='verificationBox text-center mx-2' />}
                  />
                </div>
              </div>
            }
            {!showCode &&
              // <div className="form-outline">
              //   <label className="form-label mt-4">Mobile Number</label>
              //   <div className='d-flex'>
              //   <input type="text" id="form3Example3" className="form-control mobile1"
              //     placeholder="+91" />
              //   <input type="text" id="form3Example3" className="form-control"
              //     placeholder="0000000000" />
              //   </div>
              // </div>
              <>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-outline">
                    <label className="form-label mt-4">Email</label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field }) => (
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter your email" {...field} />
                      )}
                    />
                    {errors.email && <p className="errorText">{errors.email.message}</p>}
                  </div>
                  <div className="form-outline position-relative">
                    <label className="form-label mt-3">Password</label>
                    <Controller
                      name="password"
                      control={control}
                      render={({ field }) => (
                        <input
                          type={passwordType}
                          className="form-control"
                          placeholder="Enter your password" {...field} />
                      )}
                    />
                    <div className='eye-icon' onClick={togglePassword}>
                      {passwordType === "password" ? <FaEyeSlash size={20} color='#7265E3' /> : <FaEye color='#7265E3' size={20} />}
                    </div>
                    {errors.password && <p className="errorText">{errors.password.message}</p>}
                  </div>
                  <div className="text-center align-items-center mt-3">
                    <button type="submit" className='purple-btn w-100'>Log in</button>
                  </div>
                </form>
              </>
            }

            {showCode &&
              <div className="text-center align-items-center mt-3">
                <button type="button" className='purple-btn w-100' onClick={routeChange}>Continue</button>
              </div>
            }

            {/* {!showCode &&
              <div className="text-center align-items-center mt-3">
                <button type="submit" className='purple-btn w-100'>Log in</button>
              </div>
            } */}
            {showCode && <p className='resendText text-center'>Didn't get the code? <a href='' style={{ textDecoration: 'none', color: '#7265E3', fontWeight: 600 }}>Resend</a></p>}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Login